module.exports = __webpack_public_path__ + "static/media/spain.c87fab1c.jpg";